module.exports = __webpack_public_path__ + "static/img/modallight.98cb97e2.png";